import React, { useState } from 'react';
import { useData } from '../../context/DataContext';
import { Plus, BookOpen } from 'lucide-react';
import { cn } from '../../lib/utils';

export default function Subjects() {
    const { subjects, addSubject } = useData();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newSubject, setNewSubject] = useState({ name: '', code: '' });

    const handleSubmit = (e) => {
        e.preventDefault();
        if (newSubject.name && newSubject.code) {
            addSubject(newSubject);
            setNewSubject({ name: '', code: '' });
            setIsModalOpen(false);
        }
    };

    return (
        <div className="space-y-6">
            <div className="flex items-center justify-between">
                <div>
                    <h1 className="text-2xl font-bold font-heading text-primary">Subjects</h1>
                    <p className="text-muted-foreground">Manage curriculum subjects</p>
                </div>
                <button
                    onClick={() => setIsModalOpen(true)}
                    className="flex items-center gap-2 bg-primary text-primary-foreground px-4 py-2 rounded-lg font-medium hover:bg-primary/90 transition-colors shadow-lg shadow-primary/20"
                >
                    <Plus size={18} />
                    Add Subject
                </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {subjects.map((subject) => (
                    <div key={subject.id} className="bg-card border border-border/50 p-6 rounded-2xl shadow-sm hover:shadow-md transition-all group">
                        <div className="flex items-start justify-between mb-4">
                            <div className="h-12 w-12 bg-secondary rounded-xl flex items-center justify-center text-primary group-hover:scale-110 transition-transform">
                                <BookOpen size={24} />
                            </div>
                            <span className="text-xs font-bold px-2 py-1 bg-secondary rounded-md text-muted-foreground">{subject.code}</span>
                        </div>
                        <h3 className="text-lg font-bold text-foreground">{subject.name}</h3>
                        <p className="text-sm text-muted-foreground mt-1">Active Curriculum</p>
                    </div>
                ))}
            </div>

            {isModalOpen && (
                <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
                    <div className="bg-card w-full max-w-md p-6 rounded-2xl shadow-2xl border border-border anim-scale-in">
                        <h2 className="text-xl font-bold mb-4 font-heading">Add New Subject</h2>
                        <form onSubmit={handleSubmit} className="space-y-4">
                            <div>
                                <label className="text-sm font-medium text-muted-foreground block mb-1">Subject Name</label>
                                <input
                                    type="text"
                                    value={newSubject.name}
                                    onChange={(e) => setNewSubject({ ...newSubject, name: e.target.value })}
                                    className="w-full bg-secondary border-transparent focus:border-primary focus:ring-0 rounded-lg px-4 py-2.5"
                                    placeholder="e.g. Data Structures"
                                    required
                                />
                            </div>
                            <div>
                                <label className="text-sm font-medium text-muted-foreground block mb-1">Subject Code</label>
                                <input
                                    type="text"
                                    value={newSubject.code}
                                    onChange={(e) => setNewSubject({ ...newSubject, code: e.target.value })}
                                    className="w-full bg-secondary border-transparent focus:border-primary focus:ring-0 rounded-lg px-4 py-2.5"
                                    placeholder="e.g. CS102"
                                    required
                                />
                            </div>
                            <div className="flex gap-3 pt-2">
                                <button
                                    type="button"
                                    onClick={() => setIsModalOpen(false)}
                                    className="flex-1 px-4 py-2 rounded-lg border border-border text-muted-foreground hover:bg-secondary font-medium"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="flex-1 px-4 py-2 rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 font-medium"
                                >
                                    Create
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
